import { IBasicUserInfo } from '../resources/models/IUserInfo';
import { UUID } from '../types/uuid';
import { createContext } from 'react';

export interface IUserContext {
  user: null | IBasicUserInfo;
  userId: null | UUID;
}

export const UserContext = createContext<IUserContext>({
  user: null,
  userId: null,
});
